<template>
	<div class="p-relative p-width100 p-line-height2 p-font1 p-color3 p-center" style="z-index:0; margin-top:4rem;">		
		<div>
			<img
				class="icon iconfont icon-baobiao2 p-color5"  
				style="font-size:3rem; line-height:1;width: 30%;height: auto;"  
				type="icon-baobiao2"
				src="../../assets/img/lista2.png"
			>
			</img>
		</div>
		
        <div  class="p-color3"> {{$t('common.noContainData')}}</div>
	</div>
</template>



<script>
	export default {
		name: "no-content",
		data() {
			return {
				
			};
		},
		props:{
			// isCenter:{  type:Boolean, default:false  },
		},


	}
</script>

<style scoped>
	.fixedMiddle {
		position: fixed;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%);
	}
</style>
